import React, { memo, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro';
import PropTypes from 'prop-types';

import useWindowSize from '../../../../../helpers/hooks/useWindowSize';
import { DEFAULT_FN, POPUP_TYPE } from '../../../../../constants';

import SellingGroupFilterChoose from './SellingGroupFilterChoose';

import { setShow } from '../../../../../actions/general';
import { removeSearchParamSellingGroupFilterClosePopup, setSubscriberSellingGroupFilterOptions } from '../actions';

const SellingGroupFilterPopup = (props) => {
     const { onApplyFilter, handleClearAllFilter } = props;

     const { width } = useWindowSize();

     const [searchParams, setSearchParams] = useSearchParams();
     const paramSearch = new URLSearchParams(searchParams);

     const dispatch = useDispatch();

     const show = useSelector((state) => state.general.show);
     const sellingGroupFilterOptions = useSelector((state) => state.subscriber.sellingGroupFilterOptions);
     const sellingGroupFilterSelectedItems = useSelector((state) => state.subscriber.sellingGroupFilterSelected.items);

     const sellingGroupFilterOptionsBackupRef = useRef(sellingGroupFilterOptions);

     useEffect(() => {
          if (width > 991 && show === POPUP_TYPE.SELLING_GROUP_FILTER_CHOOSE) {
               handleClose();
          }
     }, [width]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleClose = () => {
          dispatch(setSubscriberSellingGroupFilterOptions(sellingGroupFilterOptionsBackupRef.current));

          const newSearchParams = removeSearchParamSellingGroupFilterClosePopup(sellingGroupFilterOptionsBackupRef.current, paramSearch);
          setSearchParams(newSearchParams);

          dispatch(setShow(null));
     };

     const handleApplyFilter = () => {
          dispatch(setShow(null));
          onApplyFilter();
     };

     return (
          <CModal visible className="selling-group-filter-popup" onClose={handleClose}>
               <CModalHeader closeButton={false}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                         <h4 className="modal-title">Filter Products</h4>
                         {sellingGroupFilterSelectedItems.length > 0 && (
                              <span className="modal-clear" onClick={handleClearAllFilter}>
                                   Clear All
                              </span>
                         )}
                    </div>
                    <div className="modal-close" onClick={handleClose}>
                         <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                   d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                                   fill="currentColor"
                              />
                         </svg>
                    </div>
               </CModalHeader>
               <CModalBody>
                    <SellingGroupFilterChoose />
               </CModalBody>
               <CModalFooter>
                    <CButton className="btn btn-primary btn-primary-v2 selling-group-filter-btn-apply" onClick={handleApplyFilter}>
                         Apply Filter
                    </CButton>
               </CModalFooter>
          </CModal>
     );
};

SellingGroupFilterPopup.propTypes = {
     onApplyFilter: PropTypes.func,
     handleClearAllFilter: PropTypes.func,
};

SellingGroupFilterPopup.defaultProps = {
     onApplyFilter: DEFAULT_FN,
     handleClearAllFilter: DEFAULT_FN,
};

export default memo(SellingGroupFilterPopup);
